import { CodetableMetadata } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { FilterOption } from 'app/components/options-handler/types';
import { CreateEmptyCodeItemPayload } from 'app/area/codetable/item/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

const createCaseType = (metadata: CodetableMetadata, caseTypesOptions: FilterOption) => {
  const caseTypes = !!caseTypesOptions ? caseTypesOptions.codes as CodeComplexValue<number>[] : [];

  return metadata && metadata.features && metadata.features.caseType ? caseTypes : undefined;
};

const createExcludeFields = (metadata: CodetableMetadata) => {
  return (metadata && metadata.features && metadata.features.visible) ? [] : undefined;
};

const createCodetableTypes = (metadata: CodetableMetadata) => {
  return (metadata && metadata.codetableClass && isDefinedIncludingZero(metadata.codetableClass.id)) ? [] : undefined;
};

export const createParent = (metadata: CodetableMetadata, parent: CodeComplexValue<number>, parentId: number) => {
  return parentId && metadata && metadata.features && metadata.features.hierarchy ? parent : undefined;
};

const createCategory = (metadata: CodetableMetadata, category: CodeComplexValue<number>) => {
  return !!metadata && !!metadata.codetableCategory && isDefinedIncludingZero(metadata.codetableCategory.id) ? category : undefined;
};

const createUserGroups = (metadata: CodetableMetadata, userGroupsOptions: FilterOption) => {
  const userGroups = !!userGroupsOptions ? userGroupsOptions.codes : [];

  return metadata && metadata.features && metadata.features.userGroup ? userGroups as CodeComplexValue<number>[] : undefined;
};

const createDescriptions = (metadata: CodetableMetadata, languagesOptions: FilterOption) => {
  const languages = !!languagesOptions ? languagesOptions.codes : [];

  return metadata && metadata.features && metadata.features.description
    ? languages.map(language => ({ value: language.value })) as CodeComplexValue<number>[]
    : undefined;
};

export const createEmptyCodeItem = (payload: CreateEmptyCodeItemPayload): CodeItem => {
  const { caseTypes, metadata, parent, category, parentId, userGroups, languages, substanceUomSet } = payload;

  return {
    caseTypes: createCaseType(metadata, caseTypes),
    category: createCategory(metadata, category),
    codetableTypes: createCodetableTypes(metadata),
    colour: undefined,
    description: createDescriptions(metadata, languages),
    disabled: undefined,
    excludeFields: createExcludeFields(metadata),
    icon: undefined,
    id: undefined,
    name: undefined,
    longDescription: createDescriptions(metadata, languages),
    node: undefined,
    parent: createParent(metadata, parent, parentId),
    sequence: undefined,
    userGroups: createUserGroups(metadata, userGroups),
    colourCode: undefined,
    residualIcon: undefined,
    ...(substanceUomSet && { substanceUomSet })
  };
};
